export const COORDINATOR = {
  id: 0,
  name: "Ja",
  role: "Koordynator",
  phone: "",
};

export const CONTACTS = [
  { id: 1, name: "Jan", role: "Catering", phone: "+48 501 235 205" },
  { id: 2, name: "Marysia", role: "Recepcja", phone: "+48 624 071 129" },
  { id: 3, name: "Tomek", role: "Hostessy", phone: "+48 943 873 923" },
  { id: 4, name: "Basia", role: "Backstage", phone: "+48 394 927 237" },
  { id: 5, name: "John", role: "Ochrona", phone: "+48 172 034 824" },
];

export const ALL_ASSIGNEES = [
  COORDINATOR,
  { id: -1, name: "Nieprzypisane", role: "Do przypisania później", phone: "" },
  ...CONTACTS,
];

export const STATUS = {
  new: {
    label: "Nowe",
    color: "var(--badge-new-text)",
    bg: "var(--badge-new-bg)",
    border: "var(--badge-new-border)",
    dot: "var(--badge-new-text)",
  },
  in_progress: {
    label: "W realizacji",
    color: "var(--badge-progress-text)",
    bg: "var(--badge-progress-bg)",
    border: "var(--badge-progress-border)",
    dot: "var(--badge-progress-text)",
  },
  done: {
    label: "Wykonane",
    color: "var(--badge-done-text)",
    bg: "var(--badge-done-bg)",
    border: "var(--badge-done-border)",
    dot: "var(--badge-done-text)",
  },
  problem: {
    label: "Problem",
    color: "var(--badge-problem-text)",
    bg: "var(--badge-problem-bg)",
    border: "var(--badge-problem-border)",
    dot: "var(--badge-problem-text)",
  },
};
